import { useEffect, useState } from "react";
import { DashboardData } from "../components/dashboard/types";
import { Backend } from "../url";

const useDashboardData = (experimentId?: string) => {
  const [dashboardData, setDashboardData] = useState<DashboardData | null>(
    null
  );
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);

        const params = new URLSearchParams();
        if (experimentId) {
          params.append("experiment_id", experimentId);
        }

        const url = `${Backend}/search/dashboard${
          params.toString() ? `?${params.toString()}` : ""
        }`;
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(
            `Failed to fetch dashboard data: ${response.statusText}`
          );
        }

        const data: DashboardData = await response.json();
        setDashboardData(data);
        setError(null);
      } catch (err) {
        console.error("Failed to load dashboard data:", err);
        setError(
          err instanceof Error ? err.message : "An unknown error occurred"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, [experimentId]);

  return { dashboardData, loading, error };
};

export default useDashboardData;
